import styled from "styled-components";

export const InputText = ({
  text,
  setText,
  labelOfInput,
  type,
  placeholder,
  inputName,
  handleKeyDown = () => {},
  heightOfInput,
  widthOfInput,
  inputRef,
  requiredOption,
  isDisabledInput,
}) => {
  return (
    <Label height={heightOfInput} width={widthOfInput} className="labelForText">
      {" "}
      {labelOfInput && (
        <span>
          {" "}
          {labelOfInput} {requiredOption && <span> *</span>}
        </span>
      )}
      <input
        type={type ? type : "text"}
        name={inputName}
        value={text}
        onKeyDown={handleKeyDown}
        onChange={setText}
        className="inputBox"
        placeholder={placeholder ? placeholder : "Type here"}
        ref={inputRef}
        disabled={isDisabledInput}
      />
    </Label>
  );
};

export const ShowError = ({ errorText }) => {
  return <ShowErrorCss>{errorText}</ShowErrorCss>;
};

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  color: var(--GREY, #4a4a68);
  line-height: 20px;
  font-weight: 400;
  width: 100%;

  > span > span {
    color: var(--DANGER, #cf324a);
  }

  .inputBox {
    height: ${props => props.height || "40px"};
    width: ${props => props.width || "auto"};
    display: flex;
    padding: 8px 4px 8px 8px;
    color: var(--GREY, #4a4a68);
    font-weight: 400;
    line-height: 22px;
    border-radius: 4px;
    border: 1px solid var(--LIGHT-ASH, #b9b9c6);
    background-color: var(--Cloud, #fcfdfe);
    outline: none;
    font-size: 14px;

    &:hover {
      border-color: var(--DARK-BLUE, #1249bf);
    }
    &:focus {
      border-color: var(--DARK-BLUE, #1249bf);
      .labelForText {
        border-color: var(--DARK-BLUE, #1249bf) !important;
      }
    }
  }
`;

export const ShowErrorCss = styled.div`
  height: 22px;
  color: #cf324a;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Figtree;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-top: 4px;
`;
